import { Box, Button, Card, CardBody, CardFooter, CardHeader, Flex, HStack, Heading, Link, List, ListIcon, ListItem, Stack, StackDivider, Text, UnorderedList, VStack } from "@chakra-ui/react";
import { BiInfoCircle } from "react-icons/bi";
import React from "react";
import { ChainNetworkBadge } from "./ChainNetworkBadge";

type ContractTooltipCardType = {
    isTestnet: boolean;
    contract: string;
    contractUri: string;
}
export const ContractTooltipCard = (data: ContractTooltipCardType) => {
    return (
        <Card width="340px" m={5}>
            <CardHeader>
                <Heading size='md'>Tooltips</Heading>
            </CardHeader>
            <CardBody>
                <Stack divider={<StackDivider/>} spacing={2}>
                    <Box>
                        <Heading size='xs'>Network</Heading>
                        <ChainNetworkBadge testnet={data.isTestnet} />
                    </Box>
                    <Box>
                        <Heading size='xs'>Type</Heading>
                        <Text pt='2' fontSize='sm'>SBT(Soulbound Token)</Text>
                    </Box>
                    <Box>
                        <Heading size='xs'>Features</Heading>
                        <UnorderedList pt='2' spacing={2} fontSize='sm'>
                            <ListItem>Non-transferable</ListItem>
                            <ListItem>Cannot sold on NFT market</ListItem>
                        </UnorderedList>
                    </Box>
                </Stack>
            </CardBody>
            <CardFooter>
                <Button flex='1' variant='ghost' as={Link} target="_blank" href={data.contractUri}>Contract</Button>
            </CardFooter>
        </Card>
    );
}